import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { KBQSelectedOptions } from 'components/KBQSelect'

const initialState: KBQSelectedOptions[] = []

const selectedLostShopperKBQOptionsSlices = createSlice({
  name: 'SelectedKBQOptions',
  initialState,
  reducers: {
    setSelectKBQOption(state, action: PayloadAction<KBQSelectedOptions>) {
      return state.filter(({ id }) => id !== action.payload.id).concat(action.payload)
    },
    clearSelectKBQOptions(state) {
      return initialState
    },
  },
})

export const { setSelectKBQOption, clearSelectKBQOptions } =
  selectedLostShopperKBQOptionsSlices.actions

export default selectedLostShopperKBQOptionsSlices.reducer
